<template>
  <b-overlay :show="loading" rounded="sm">
    <b-row>
      <b-col>
        <b-card title="جزئیات تخفیف">
          <b-form @submit.prevent>
            <b-row>
              <b-col
                class="mt-2"
                md="8"
                offset-md="2"
              >
                <b-row>
                  <div class="col-12 mb-2">
                    <div class="row custom-options-checkable">
                      <div class="col-md-6 mb-md-0 mb-2">
                        <input v-model="Form.IsDynamic" class="custom-option-item-check" id="manual" type="radio" name="newAddress" :value="false" checked>
                        <label for="manual" class="custom-option-item px-2 py-1">
                          <span class="d-flex align-items-center mb-50">
                            <feather-icon
                                icon="HashIcon"
                                size="21"
                                class="mr-50"
                            />
                            <span class="custom-option-item-title h4 fw-bolder mb-0">عادی</span>
                          </span>
                          <span class="d-block">این تخفیف قابلیت استفاده در پیام را ندارد.</span>
                        </label>
                      </div>
                      <div class="col-md-6 mb-md-0 mb-2">
                        <input v-model="Form.IsDynamic" class="custom-option-item-check" id="automention" type="radio" name="newAddress" :value="true">
                        <label for="automention" class="custom-option-item px-2 py-1">
                          <span class="d-flex align-items-center mb-50">
                            <feather-icon
                                icon="HashIcon"
                                size="21"
                                class="mr-50"
                            />
                            <span class="custom-option-item-title h4 fw-bolder mb-0">پویا</span>
                          </span>
                          <span class="d-block">این تخفیف برای استفاده در اتومنشن می باشد.</span>
                        </label>
                      </div>
                    </div>
                  </div>

                  <b-col md="4">
                    <b-form-group
                      label="عنوان"
                      label-for="Title"
                    >
                      <b-form-input
                        id="Title"
                        v-model="Form.Title"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="کد"
                      label-for="Code"
                    >
                      <b-form-input
                        id="Code"
                        v-model="Form.Code"
                        autocomplete="off"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="نوع"
                      label-for="Type"
                    >
                      <v-select
                        v-model="Form.Type"
                        dir="rtl"
                        :reduce="x => x.value"
                        label="text"
                        input-id="Type"
                        :clearable="false"
                        :disabled="isCompriseDiet"
                        :options="enums('AmountType')"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                      label="مقدار"
                      label-for="Amount"
                    >
                      <b-form-input
                        id="Amount"
                        v-model="Form.Amount"
                        type="number"
                        autocomplete="off"
                        :disabled="isCompriseDiet"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                    <b-form-group
                        label="سقف مبلغ"
                        label-for="MaxPrice"
                    >
                      <b-input-group>
                        <b-input-group-prepend is-text>
                          تومان
                        </b-input-group-prepend>
                        <cleave
                            id="MaxPrice"
                            v-model="Form.MaxPrice"
                            class="form-control"
                            :raw="false"
                            :options="options"
                            :disabled="Form.Type === 1 || isCompriseDiet"
                        />
                      </b-input-group>
                    </b-form-group>
                  </b-col>

                  <b-col md="4">
                  </b-col>

                  <template v-if="!Form.IsDynamic">
                    <b-col md="4">
                      <b-form-group
                          label="تعداد"
                          label-for="Count"
                      >
                        <b-form-input
                            id="Count"
                            v-model="Form.Count"
                            type="number"
                            autocomplete="off"
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group
                          label="تاریخ شروع"
                          label-for="StartDate"
                      >
                        <date-picker
                            v-model="Form.StartDate"
                            placeholder=""
                        />
                      </b-form-group>
                    </b-col>

                    <b-col md="4">
                      <b-form-group
                          label="تاریخ پایان"
                          label-for="EndDate"
                      >
                        <date-picker
                            v-model="Form.EndDate"
                            placeholder=""
                        />
                      </b-form-group>
                    </b-col>
                  </template>
                  <template v-else>
                    <b-col md="4">
                      <b-form-group
                          label="اعتبار"
                          label-for="ValidityDay"
                      >
                        <b-input-group>
                          <b-input-group-prepend is-text>
                            روز
                          </b-input-group-prepend>
                          <cleave
                              id="ValidityDay"
                              v-model="Form.ValidityDay"
                              class="form-control"
                              :raw="false"
                              :options="options"
                          />
                        </b-input-group>
                      </b-form-group>
                    </b-col>
                  </template>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                          v-model="Form.CompriseActivityGroup"
                          value="true"
                          class="custom-control-success"
                      >
                        تخفیف برای گروه های ورزشی قابل استفاده می باشد.
                      </b-form-checkbox>

                    </b-form-group>
                  </b-col>

                  <b-col md="12" v-show="Form.CompriseActivityGroup">
                    <b-form-group
                        class="mt-1"
                        label="گروه"
                    >
                      <z-activity-group
                          v-model="Form.ActivityGroupIds"
                          :multiple="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                          v-model="Form.Deactive"
                          value="true"
                          class="custom-control-danger"
                      >
                        غیر فعال
                      </b-form-checkbox>

                    </b-form-group>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

                  <b-col cols="12">
                    <b-form-group class="mt-1">
                      <b-form-checkbox
                          v-model="Form.CompriseDiet"
                          value="true"
                          class="custom-control-success"
                      >
                        تخفیف برای رژیم های غذایی قابل استفاده می باشد.
                      </b-form-checkbox>
                    </b-form-group>
                  </b-col>

                  <b-col
                      cols="12"
                      v-if="Form.CompriseDiet"
                  >
                    <b-row
                        v-for="(item, index) in Form.CouponDiet"
                        :key="index"
                        class="mb-1 border-bottom"
                    >
                      <b-col cols="10">
                        <b-row>
                          <b-col md="6">
                            <b-form-group
                                label="نوع"
                                label-for="DietType"
                            >
                              <v-select
                                  v-model="item.DietType"
                                  dir="rtl"
                                  :reduce="x => x.value"
                                  label="text"
                                  input-id="DietType"
                                  :clearable="false"
                                  :options="enums('DietType')"
                                  :selectable="x => Form.CouponDiet.map(x => x.DietType).includes(x.value) === false"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="6">
                            <b-form-group
                                label="دوره"
                                label-for="DietDuration"
                            >
                              <z-diet-duration
                                  v-model="item.DietDurationIds"
                                  :multiple="true"
                                  id="DietDuration"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <b-form-group
                                label="نوع تخفیف"
                                label-for="Type"
                            >
                              <v-select
                                  v-model="item.Type"
                                  dir="rtl"
                                  :reduce="x => x.value"
                                  label="text"
                                  input-id="Type"
                                  :clearable="false"
                                  :options="enums('AmountType')"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <b-form-group
                                label="مقدار"
                                label-for="Amount"
                            >
                              <b-form-input
                                  id="Amount"
                                  v-model="item.Amount"
                                  type="number"
                                  autocomplete="off"
                              />
                            </b-form-group>
                          </b-col>

                          <b-col md="4">
                            <b-form-group
                                label="سقف مبلغ"
                                label-for="MaxPrice"
                            >
                              <b-input-group>
                                <b-input-group-prepend is-text>
                                  تومان
                                </b-input-group-prepend>
                                <cleave
                                    id="MaxPrice"
                                    v-model="item.MaxPrice"
                                    class="form-control"
                                    :raw="false"
                                    :options="options"
                                    :disabled="item.Type === 1"
                                />
                              </b-input-group>
                            </b-form-group>
                          </b-col>
                        </b-row>
                      </b-col>
                      <b-col md="2" class="mb-1" style="display: flex; align-items: center;">
                        <template v-if="couponDietRemoveId !== index">
                          <b-button
                              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                              variant="outline-danger"
                              class="btn-icon rounded-circle"
                              @click="removeCouponDiet(index)"
                          >
                            <feather-icon
                                icon="TrashIcon"
                            />
                          </b-button>
                        </template>
                        <template v-else>
                          <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              class="btn-icon rounded-circle"
                              variant="outline-primary"
                              @click="cancelRemoveCouponDiet"
                          >
                            <feather-icon icon="XIcon" />
                          </b-button>
                          <b-button
                              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                              class="btn-icon rounded-circle ml-1"
                              variant="outline-primary"
                              @click="confirmRemoveCouponDiet"
                          >
                            <feather-icon icon="CheckIcon" />
                          </b-button>
                        </template>
                      </b-col>
                    </b-row>
                  </b-col>

                  <b-col
                      cols="12"
                      v-if="Form.CompriseDiet"
                  >
                    <b-button
                        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                        variant="gradient-info"
                        class="mb-1"
                        @click="addCouponDiet"
                    >
                      <feather-icon
                          icon="PlusIcon"
                          class="mr-25"
                      />
                      <span>افزودن</span>
                    </b-button>
                  </b-col>

                  <b-col cols="12">
                    <hr>
                  </b-col>

     <template v-if="!Form.IsDynamic">
       <b-col cols="12">
         <b-form-group class="mt-1">
           <b-form-checkbox
               v-model="Form.IsPrivate"
               value="true"
               class="custom-control-success"
           >
             تخفیف اختصاصی می باشد.
           </b-form-checkbox>

         </b-form-group>
       </b-col>

       <template v-if="Form.IsPrivate">
         <b-col cols="12">
           <b-row class="mt-1" v-if="Form.UserIds.length">
             <b-col md="10">
               <label style="font-weight: 600;">کاربر</label>
             </b-col>
           </b-row>

           <b-row
               v-for="(item, index) in Form.UserIds"
               v-show="userRemoveIds.includes(index) === false"
               :key="index"
               class="mb-1"
           >
             <b-col md="10">
               <b-form-group>
                 <z-user
                     v-model="Form.UserIds[index]"
                     :clearable="false"
                     :disabled="Form.UserIds[index]"
                 />
               </b-form-group>
             </b-col>

             <b-col
                 md="2"
                 class="mb-1"
                 style="display: flex; align-items: center;"
             >
               <template v-if="userRemoveId !== index">
                 <b-button
                     v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                     variant="outline-danger"
                     class="btn-icon rounded-circle"
                     @click="removeUser(index)"
                 >
                   <feather-icon
                       icon="TrashIcon"
                   />
                 </b-button>
               </template>
               <template v-else>
                 <b-button
                     v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                     class="btn-icon rounded-circle"
                     variant="outline-primary"
                     @click="cancelRemoveUser"
                 >
                   <feather-icon icon="XIcon" />
                 </b-button>
                 <b-button
                     v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                     class="btn-icon rounded-circle ml-1"
                     variant="outline-primary"
                     @click="confirmRemoveUser"
                 >
                   <feather-icon icon="CheckIcon" />
                 </b-button>
               </template>
             </b-col>

           </b-row>
         </b-col>

         <b-col cols="12">
           <b-button
               v-ripple.400="'rgba(255, 255, 255, 0.15)'"
               variant="gradient-info"
               class="mb-1"
               @click="addUser"
           >
             <feather-icon
                 icon="PlusIcon"
                 class="mr-25"
             />
             <span>افزودن</span>
           </b-button>
         </b-col>
       </template>

       <b-col cols="12">
         <hr>
       </b-col>
     </template>



                  <b-col class="mt-1 mb-2 text-center">
                    <b-button
                      v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                      type="submit"
                      variant="primary"
                      class="mr-1"
                      @click="save"
                    >
                      ذخیره
                    </b-button>
                    <b-button
                      v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                      variant="outline-secondary"
                      @click="back"
                    >
                      بازگشت
                    </b-button>
                  </b-col>

                </b-row>
              </b-col>
            </b-row>
          </b-form>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>

<script>

import flatPickr from 'vue-flatpickr-component'
import ZUser from '@/tools/user.vue'
import ZDietDuration from '@/tools/dietduration.vue'
import ZActivityGroup from '@/tools/activitygroup'

export default {
  name: 'DiscountDetails',
  components: {
    flatPickr,
    ZUser,
    ZDietDuration,
    ZActivityGroup,
  },
  data() {
    return {
      Form: {
        Id: null,
        MaxPrice: 0,
        Count: null,
        Amount: 0,
        Code: null,
        Title: null,
        StartDate: null,
        EndDate: null,
        IsPrivate: false,
        UserIds: [],
        Type: 0,
        CompriseActivityGroup: false,
        CompriseDiet: false,
        ActivityGroupIds: [],
        CouponDiet: [],
        IsDynamic: false,
        ValidityDay: null,
        Deactive: true
      },
      options: {
        numeral: true,
        numeralThousandsGroupStyle: 'thousand',
        numeralDecimalScale: 4,
      },
      userRemoveId: null,
      couponDietRemoveId: null,
      userRemoveIds: [],
      loading: false,
    }
  },
  computed: {
    isCompriseDiet() {
      return this.Form.CompriseDiet
    }
  },
  watch: {
    'Form.CompriseDiet': {
      handler(val) {
        if (val) {
          this.Form.Type = 0
          this.Form.Amount = 0
          this.Form.MaxPrice = 0
        }
      }
    }
  },
  created() {
    if (this.$route.params.id) {
      this.Form.Id = this.$route.params.id
      this.get()
    }else {
      this.addUser()
      this.addCouponDiet()
    }
  },
  methods: {
    save() {
      let url = this.$api.discount.add
      if (this.$route.params.id) {
        url = this.$api.discount.update
      }

      const form = JSON.parse(JSON.stringify(this.Form))
      form.MaxPrice = form.MaxPrice.replaceAll(',', '')
      const useIds = form.UserIds
      form.UserIds = []

      useIds.forEach((item, index) => {
        if (this.userRemoveIds.includes(index) === false && item) {
          form.UserIds.push(item)
        }
      })

      const couponDiet = form.CouponDiet
      form.CouponDiet = []

      couponDiet.forEach((item, index) => {
        if (item.DietType || item.DietType === 0) {
          form.CouponDiet.push({
            ...item,
            MaxPrice: String(item.MaxPrice).replaceAll(',', '') * 1,
            Amount: item.Amount * 1
          })
        }
      })

      this.loading = true
      this.$http.post(
        url, form,
      )
        .then(() => {
          this.back()
        })
        .finally(() => {
          this.loading = false
        })
    },
    get() {
      this.loading = true
      this.$http.post(
        this.$api.discount.get, {
          Id: this.Form.Id,
        },
      )
        .then(res => {
          this.loading = false
          this.Form = res.data
        })
    },
    addCouponDiet(){
      this.Form.CouponDiet.push({
        DietType: null,
        DietDurationIds: [],
        Type: null,
        Amount: null,
        MaxPrice: null
      })
    },
    addUser() {
      this.Form.UserIds.push(null)
    },
    removeUser(index) {
      this.userRemoveId = index
    },
    confirmRemoveUser() {
      // this.Form.UserIds.splice(this.userRemoveId, 1)
      this.userRemoveIds.push(this.userRemoveId)
      this.userRemoveId = null
    },
    cancelRemoveUser() {
      this.userRemoveId = null
    },
    removeCouponDiet(index) {
      this.couponDietRemoveId = index
    },
    confirmRemoveCouponDiet() {
      this.Form.CouponDiet.splice(this.couponDietRemoveId, 1)
      this.couponDietRemoveId = null
    },
    cancelRemoveCouponDiet() {
      this.couponDietRemoveId = null
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.invoice-add-wrapper {
  .add-new-client-header {
    padding: $options-padding-y $options-padding-x;
    color: $success;

    &:hover {
      background-color: rgba($success, 0.12);
    }
  }
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import '~@core/scss/base/components/variables-dark';

.form-item-section {
  background-color:$product-details-bg;
}

.form-item-action-col {
  width: 27px;
}

.repeater-form {
  // overflow: hidden;
  transition: .35s height;
}

.v-select {
  &.item-selector-title,
  &.payment-selector {
    background-color: #fff;

    .dark-layout & {
      background-color: unset;
    }
  }
}

.dark-layout {
  .form-item-section {
    background-color: $theme-dark-body-bg;

    .row .border {
      background-color: $theme-dark-card-bg;
    }

  }
}

.custom-options-checkable .custom-option-item {
  width: 100%;
  cursor: pointer;
  border-radius: 0.42rem;
  color: #82868B;
  background-color: rgba(130,134,139,.06);
  border: 1px solid #EBE9F1;
}

.custom-option-item-check:checked+.custom-option-item {
  color: #7367F0;
  background-color: rgba(115,103,240,.12);
  border-color: #7367F0;
}

.custom-option-item-check {
  position: absolute;
  clip: rect(0,0,0,0);
}
.mr-50{
  margin-right: 0.5rem;
}

.custom-options-checkable .custom-option-item .custom-option-item-title {
  color: #82868B;
}

.custom-option-item-check:checked+.custom-option-item .custom-option-item-title {
  color: #7367F0;
}
</style>
